var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-editar-permissoes',{ref:"componenteFilho"},[_c('v-icon',{attrs:{"right":"","small":""},on:{"click":function($event){_vm.disparEventoAbrirOuFecharModal(), _vm.dispararEventoUsuarioSelecionadoParaEdicao()}}},[_vm._v(" mdi-pencil ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }